import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material";
import theme from "./theme/index";
import routers from "./screens/routes";
import GuardRoute from "./shared/utils/GuardRoute";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          {routers.map((route) => {
            const isPrivate = !["/login", "/set-password", "/reset-password-request"].includes(route.path as string);

            return (
              <Route
                key={route.path}
                path={route.path}
                element={
                  <GuardRoute isPrivate={isPrivate}>
                    { route.element }
                  </GuardRoute>
                }
              />
            );
          })}
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;